<template>
	<modal ref="editInvoiceModal" :modalSizeClasses="'small-12 large-4 columns small-centered editModal editInvoiceModal'" v-if="openModal" @closeModal="closeModal">
        <div class="small-12 columns modalHeaderWrap flex vertical-align" slot="header" v-if="invoice">
			<a class="closeModal" @click="closeTheModal()">
                <i class="material-icons-outlined cRed">cancel</i>
            </a>
            <h2 class="small-12">Edit Invoice</h2>
            <p class="small-12 editID" style="margin-bottom:10px;">
                inv_{{invoice.id}}
            </p>
            <ul class="small-12 flex vertical-align float-left attributes">
                <li>
                    <p>
                        <b>Amount: </b>
                        ${{invoice.attributes.charge.total | convertCentsToDollars}}
                    </p>
                </li>
                <li class="flex justify-center">
                    <i class="separator round"></i>
                </li>
                <li>
                    <p>
                        <b>Late Fee: </b>
                        ${{invoice.attributes.charge.policy_late_fee | convertCentsToDollars}}
                    </p>
                </li>
                <li class="flex justify-center">
                    <i class="separator round"></i>
                </li>
                <li class="flex vertical-align">
                    <span class="badge borderRadius4 bgGrey" v-if="status.value == 'draft'">Draft</span>
                    <span class="badge borderRadius4 cYellow" v-else-if="status.value == 'open'">Open</span>
                    <span class="badge borderRadius4 cGreen" v-else-if="status.value == 'paid'">Paid</span>
                    <span class="badge borderRadius4 cPurple" v-else-if="status.value == 'uncollectible'">Uncollectible</span>
                    <span class="badge borderRadius4 cRed" v-else>Late</span>
                </li>
            </ul>
		</div>
        <div class="small-12 columns modalBodyWrap border-top" slot="body" v-if="invoice_options">
			<fieldset class="small-12 flex inputGroup">
				<label class="small-12">Invoice Status<em class="cRed">*</em></label>
				<div class="small-12 selectContainer borderRadius8 flex vertical-align">
                    <select name="resident" class="small-12" v-model="invoice.attributes.status" @change="statusValidation($event)">
                        <option :value="null" selected disabled>Please Choose...</option>
                        <option :value="status.value" v-for="(status, statusIndex) in invoice_options.statuses" :selected="invoice.attributes.status == status.value ? true : false" :key="statusIndex">{{status.title}}</option>
                    </select>
                </div>
                <div class="small-12 inputError flex animated fadeIn" style="margin-top:5px;" v-if="status.error.show">
                    <small class="cRed small-12">{{status.error.title}}</small>
                </div>
			</fieldset>
            <fieldset class="small-12 flex inputGroup">
                <label class="small-12">Statement Description<em class="cRed">*</em></label>
                <textarea name="description" id="description" class="borderRadius8 description" v-model="invoice.attributes.description"></textarea>
            </fieldset>
            <fieldset class="small-12 action border-top flex">
                <ul class="float-left flex vertical-align justify-center small-12">
                    <li class="small-12 large-9">
                        <a class="blueButton small-12 flex justify-center borderRadius8 vertical-align" @click="updateTheRentInvoice()" v-if="enableUpdateButton">
                            Update Rent Invoice
                        </a>
                        <a class="disabledButton small-12 flex justify-center borderRadius8 vertical-align disable" v-else>
                            Update Rent Invoice
                        </a>
                    </li>
                </ul>
			</fieldset>
        </div>
    </modal>
</template>

<script>

	// Import the mixins
    import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
    import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

    // Import the events
    import { GetInvoiceOptions } from '@/events/config/GetInvoiceOptions'
    import { GetInvoice } from '@/events/invoices/GetInvoice'
    import { GetRent } from '@/events/rent/GetRent'
    import { UpdateOpenInvoice } from '@/events/invoices/UpdateOpenInvoice'
    import { UpdateLateInvoice } from '@/events/invoices/UpdateLateInvoice'
    import { RemoveLateStatus } from '@/events/invoices/RemoveLateStatus'
    import { UpdatePaidInvoice } from '@/events/invoices/UpdatePaidInvoice'
    import { UpdateUncollectibleInvoice } from '@/events/invoices/UpdateUncollectibleInvoice'

    // Import the filters
    import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
    
    // Import the components
    import Modal from '@/components/framework/modals/Modal.vue'

	export default {

		/*
		** Set the component name
		*/

		name: 'EditInvoiceModal',

		/*
		**  Register the components
		*/

		components: {

			Modal

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            BugsnagService,
            GetInvoiceOptions,
            GetInvoice,
            GetRent,
            UpdateOpenInvoice,
            UpdateLateInvoice,
            RemoveLateStatus,
            UpdatePaidInvoice,
            MoneyConversions,
            SpinnerMethods,
            UpdateUncollectibleInvoice

		],

		/*
		**  Set the props
		*/

		props: {

			modal_action: {
                type: Boolean,
                default: false
            },

            invoice_id: {
                type: String,
                default: null
            },

            lease_id: {
                type: String,
                default: null
            },

            rent_id: {
                type: String,
                default: null
            },

            user: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

            openModal: false,
            status: {
                value: null,
                error: {
                    title: null,
                    show: false
                }
            },
            enableUpdateButton: true

		}),

		/*
		**  Watch em'
		*/

		watch: {

			modal_action: {

				immediate: true, // Load on created
				handler(modal_action) {
 
                    /*
                    **  Display the modal
                    **  @method: @here
                    */

                    if (modal_action) this.showModal();

				}

            },
            
            invoice_id: {

				immediate: true, // Load on created
				handler(invoice_id) {
 
                    /*
                    **  Get the invoice
                    **  @method: @here
                    */

                    if (invoice_id) this.getInvoiceHandler(invoice_id);

				}

            },

            rent_id: {

				immediate: true, // Load on created
				handler(rent_id) {

                    /*
                    **  Get the rent term
                    **  @method: @here
                    */

                    if (rent_id) this.getRentHandler(rent_id);

				}

            },

            invoice: {

				immediate: true, // Load on created
				handler(invoice) {

                    /*
                    **  Set the prop
                    **  @location: @here
                    */

                    if (invoice) this.status.value = this.invoice.attributes.status;

				}

            }

		},

		/*
        ** Do this first
        */

        mounted() {

            /*
            **  Get the invoice options
            **  @event: Events/Config/GetInvoiceOptions
            */

            this.getInvoiceOptionsHandler();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			showModal: function() {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.openModal = true;

                /*
                **  Set the body class
                **  @method: @here
                */

                this.addBodyClass();

                /*
                **  Reset status prop
                **  @prop: @here
                */

                this.status.value = this.invoice.attributes.status;
 
                /*
                **  Reset validation props
                **  @method: @here
                */

                this.resetValidationProps();

            },

            addBodyClass: function(){

				$('body').addClass('modalFixed');

			},

			removeBodyClass: function(){

				$('body').removeClass('modalFixed');

            },
            
            closeModal: function() {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.openModal = false;

                /*
                **  Emit the close event
                **  @service: @Vue
                */

				this.$emit('closeEditInvoiceModal');

            },

            closeTheModal: function() {

                /*
                **  Close the modal
                **  @method: @Framework/Modals/Modal
                */

				this.$refs.editInvoiceModal.handler();

            },

            statusValidation: function(event) {
 
                /*
                **  Reset validation
                **  @method: @here
                */

                this.resetValidationProps();

            },

            resetValidationProps: function() {

                /*
                **  Reset props
                **  @prop: @here
                */

                this.status.error.title = null;
                this.status.error.show = false;

                /*
                **  Enable update button
                **  @prop: @here
                */

                this.enableUpdateButton = true;
                

            },

            updateTheRentInvoice: function() {

                /* 
                ** Validate the update
                ** @method: @here
                */

				let validated = this.validate();

				if (!validated) {

                    /* 
                    ** Display error message
                    ** @service: @Window/SweetAlert
                    */

					this.$swal('Uh Oh!', 'Please fill out all required fields before updating the rent invoice.', 'error');

					return;

                }

                /* 
                ** Show the spinner
                ** @mixin: @Helpers/SpinnerMethods
                */

                this.showSpinner();

                /* 
                ** If status was late and changed
                */

                if (this.status.value == 'late' && this.invoice.attributes.status !== 'late') {

                    /* 
                    ** Remove the late status and adjust the numbers
                    ** @method: @Events/Invoices/RemoveLateStatus
                    */

                    this.removeLateStatusHandler();

                }

                /* 
                ** Update the status accordingly
                */

                if (this.invoice.attributes.status == 'open') {
                    
                    /* 
                    ** Update status to open
                    ** @method: @Events/Invoices/UpdateOpenInvoice
                    */

                    this.updateOpenInvoiceHandler();

                } else if (this.invoice.attributes.status == 'late') {

                    /* 
                    ** Update status to late
                    ** @method: @Events/Invoices/UpdateLateInvoice
                    */

                    this.updateLateInvoiceHandler();

                } else if (this.invoice.attributes.status == 'paid') {

                    /* 
                    ** Update status to paid
                    ** @method: @Events/Invoices/UpdatePaidInvoice
                    */

                    this.updatePaidInvoiceHandler();

                } else if (this.invoice.attributes.status == 'uncollectible') {

                    /* 
                    ** Update status to uncollectible
                    ** @method: @Events/Invoices/UpdateUncollectibleInvoice
                    */

                    this.updateUncollectibleInvoiceHandler();

                }

            },

             validate: function() {

				// Required fields
				if (this.invoice.attributes.description == null || this.invoice.attributes.description.length == 0) return false;
				if (this.invoice.attributes.status == 'draft') return false;

				return true;

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>